<!-- Filter Form -->
<div class="row g-4">
  <div class="col-12 col-xl-12">
    <mat-card>
      <mat-card-content>
        <h5 class="mb-3">Subject Form</h5>
        <div class="row g-3">

          <!-- Course Dropdown -->
          <div class="col-12 col-md-6">
            <mat-form-field class="w-100" appearance="fill">
              <mat-label>Course</mat-label>
              <mat-select [(ngModel)]="selectedCourseId" name="course" (selectionChange)="onFiltersChange()">
                <mat-option *ngFor="let course of courseList" [value]="course.id">
                  {{ course.name }}-{{course.crs_code}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Semester Dropdown -->
          <div class="col-12 col-md-6">
            <mat-form-field class="w-100" appearance="fill">
              <mat-label>Semester</mat-label>
              <mat-select [(ngModel)]="selectedSemesterNumber" name="semester" (selectionChange)="onFiltersChange()">
                <mat-option *ngFor="let sem of semesterList" [value]="sem.number">
                  {{ sem.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Result Type -->
          <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100 mb-3">
              <mat-label>Select Result Type</mat-label>
              <mat-select [(ngModel)]="resultType" name="resultType">
                <mat-option value="regular">Regular</mat-option>
                <mat-option value="iti">ITI</mat-option>
                <mat-option value="puc">PUC</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Action Buttons -->
          <div class="col-12 d-flex gap-2 flex-wrap">
            <button (click)="onFiltersChange()" mat-flat-button color="primary">View</button>
            <button mat-flat-button color="primary" (click)="get_all_subjects_download()">Download</button>
            <button
              mat-flat-button
              color="warn"
              (click)="delete_subjects_based_on_filters(selectedCourseId, selectedSemesterNumber)"
              [disabled]="isDeleteDisabled()"
            >
              Delete
            </button>
          </div>

          <!-- Search -->
          <div class="col-12 d-flex align-items-center gap-2 flex-wrap">
            <mat-form-field appearance="outline" class="w-50">
              <mat-label>Search</mat-label>
              <input
                matInput
                [(ngModel)]="searchText"
                placeholder="Search by Qn Code and Subject Name"
              />
            </mat-form-field>
            <button mat-flat-button color="primary" (click)="applyFilter()">Search</button>
          </div>

        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<!-- Subject List Table -->
<mat-card>
  <mat-card-title class="title-center">Subject List</mat-card-title>

  <div class="outer-scroll-wrapper">
    <div class="inner-scroll-container mat-elevation-z8">
      <table mat-table [dataSource]="subjects" class="full-width-table">

        <!-- Action Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let subject">
            <button mat-icon-button [matMenuTriggerFor]="menu">
              <mat-icon><b>⋮</b></mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="onDelete(subject)">Delete</button>
            </mat-menu>
          </td>
        </ng-container>

        <!-- S.No. -->
        <ng-container matColumnDef="sno">
          <th mat-header-cell *matHeaderCellDef>S.No.</th>
          <td mat-cell *matCellDef="let row; let i = index">{{ currentPage + i + 1 }}</td>
        </ng-container>

        <!-- Subject Columns -->
        <ng-container matColumnDef="subject_name">
          <th mat-header-cell *matHeaderCellDef>Subject Name</th>
          <td mat-cell *matCellDef="let s">{{ s.subject_name }}</td>
        </ng-container>

        <ng-container matColumnDef="qn_code">
          <th mat-header-cell *matHeaderCellDef>QN Code</th>
          <td mat-cell *matCellDef="let s">{{ s.qn_code }}</td>
        </ng-container>

        <ng-container matColumnDef="course_code">
          <th mat-header-cell *matHeaderCellDef>Course Code</th>
          <td mat-cell *matCellDef="let s">{{ s.course_code }}</td>
        </ng-container>

        <ng-container matColumnDef="course_name">
          <th mat-header-cell *matHeaderCellDef>Course Name</th>
          <td mat-cell *matCellDef="let s">{{ s.course_name }}</td>
        </ng-container>

        <ng-container matColumnDef="semester_number">
          <th mat-header-cell *matHeaderCellDef>Semester</th>
          <td mat-cell *matCellDef="let s">{{ s.semester_number }}</td>
        </ng-container>

        <ng-container matColumnDef="credits">
          <th mat-header-cell *matHeaderCellDef>Credits</th>
          <td mat-cell *matCellDef="let s">{{ s.credits }}</td>
        </ng-container>

        <ng-container matColumnDef="cie_max">
          <th mat-header-cell *matHeaderCellDef>CIE Max</th>
          <td mat-cell *matCellDef="let s">{{ s.cie_max }}</td>
        </ng-container>

        <ng-container matColumnDef="cie_pass">
          <th mat-header-cell *matHeaderCellDef>CIE Pass</th>
          <td mat-cell *matCellDef="let s">{{ s.cie_pass }}</td>
        </ng-container>

        <ng-container matColumnDef="see_max">
          <th mat-header-cell *matHeaderCellDef>SEE Max</th>
          <td mat-cell *matCellDef="let s">{{ s.see_max }}</td>
        </ng-container>

        <ng-container matColumnDef="see_pass">
          <th mat-header-cell *matHeaderCellDef>SEE Pass</th>
          <td mat-cell *matCellDef="let s">{{ s.see_pass }}</td>
        </ng-container>

        <ng-container matColumnDef="see_cond">
          <th mat-header-cell *matHeaderCellDef>SEE Cond</th>
          <td mat-cell *matCellDef="let s">{{ s.see_cond }}</td>
        </ng-container>

        <ng-container matColumnDef="subject_max">
          <th mat-header-cell *matHeaderCellDef>Sub Max</th>
          <td mat-cell *matCellDef="let s">{{ s.subject_max }}</td>
        </ng-container>

        <ng-container matColumnDef="subject_min">
          <th mat-header-cell *matHeaderCellDef>Sub Min</th>
          <td mat-cell *matCellDef="let s">{{ s.subject_min }}</td>
        </ng-container>

        <ng-container matColumnDef="psee_tmax">
          <th mat-header-cell *matHeaderCellDef>PSEE T Max</th>
          <td mat-cell *matCellDef="let s">{{ s.psee_tmax || '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="psee_tmin">
          <th mat-header-cell *matHeaderCellDef>PSEE T Min</th>
          <td mat-cell *matCellDef="let s">{{ s.psee_tmin || '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="psee_pmax">
          <th mat-header-cell *matHeaderCellDef>PSEE P Max</th>
          <td mat-cell *matCellDef="let s">{{ s.psee_pmax || '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="psee_pmin">
          <th mat-header-cell *matHeaderCellDef>PSEE P Min</th>
          <td mat-cell *matCellDef="let s">{{ s.psee_pmin || '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="gtot_max">
          <th mat-header-cell *matHeaderCellDef>GTot Max</th>
          <td mat-cell *matCellDef="let s">{{ s.gtot_max || '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="gtot_min">
          <th mat-header-cell *matHeaderCellDef>GTot Min</th>
          <td mat-cell *matCellDef="let s">{{ s.gtot_min || '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="subject_type">
          <th mat-header-cell *matHeaderCellDef>Sub Type</th>
          <td mat-cell *matCellDef="let s">{{ s.subject_type }}</td>
        </ng-container>

        <ng-container matColumnDef="scheme_type">
          <th mat-header-cell *matHeaderCellDef>Scheme</th>
          <td mat-cell *matCellDef="let s">{{ s.scheme_type }}</td>
        </ng-container>

        <!-- Row Render -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>

  <!-- Paginator -->
  <mat-paginator
    [pageSizeOptions]="[5, 10, 15, 20]"
    [length]="pagination.length"
    [pageIndex]="pagination.page - 1"
    [pageSize]="pagination.limit"
    (page)="pageEvent($event)"
    *ngIf="pagination.length"
  >
  </mat-paginator>
</mat-card>
